import { Link } from 'react-router-dom';
import Layout from '../../../../components/layout/Layout';
import Breadcrumb from '../../../../components/layout/Breadcrumb';

// ===== EN Related / Queen's Butler — mirrors JA (same structure as Butler Bell EN). External URL https://queensbutler.jp/ unchanged. Own FAQ. =====
// Images are real photos copied from the Queen's Butler site (site-queensbutler/public/img/scenes). No pricing.
// image-match-evidence: D:/AI/site-queensbutler/public/img/scenes/s19_studio_portrait-600.webp
// image-match-evidence: D:/AI/site-queensbutler/public/img/scenes/s17_footman_tea_practice-600.webp

const points = [
  { title: 'Butler salon (women only)', en: 'Butler Salon', desc: 'A salon in a mansion attended by butlers, reserved for women guests. From tea service to time spent in the house, butlers welcome you.', img: '/images/related/queens-butler/qb-salon-tea.webp', alt: 'A butler serving tea to a woman guest in a dining room with a chandelier' },
  { title: 'Studio and rental space', en: 'Studio & Space', desc: 'The furnished rooms of the mansion are available as a photo studio and as rental space.', img: '/images/related/queens-butler/qb-studio-portrait.webp', alt: 'A woman photographed at the dining table beneath a chandelier' },
  { title: 'Butler apprentice experience', en: 'Apprentice Experience', desc: 'Dress in butler attire and learn tea service and conduct as an apprentice. A chance to experience butler culture first-hand.', img: '/images/related/queens-butler/qb-footman-practice.webp', alt: 'An apprentice handling a teapot in white gloves under a butler\'s guidance' },
];

const faqs = [
  {
    q: 'What is Queen\'s Butler?',
    a: 'Queen\'s Butler is a butler salon for women operated by the Japan Butler Association.\n\nAt its mansion at 2-7-4 Aomi, Koto-ku, Tokyo, it offers a women-only butler salon, a studio and rental space, a butler apprentice experience, and an online shop.',
  },
  {
    q: 'What services are available?',
    a: 'Besides the women-only butler salon, there is a studio and rental space using the rooms of the mansion, a butler apprentice experience for learning butler attire and conduct, and an online shop offering made-to-order items themed on butler attire.',
  },
  {
    q: 'How is it related to the Japan Butler Association?',
    a: 'Queen\'s Butler is a butler salon operated by the Association. Butlers trained by the Association welcome guests at the mansion, making it one of the places where butler culture is delivered as an experience.\n\nReservations and inquiries are handled through the official site, queensbutler.jp.',
  },
];

const otherRelated = [
  { name: 'THE BUTLER', role: 'Butler service', to: '/en/related/the-butler' },
  { name: 'Butler Bell', role: 'Media brand', to: '/en/related/butler-bell' },
  { name: 'Japan Butler Academy', role: 'Training institution', to: '/en/related/butler-academy' },
];

const breadcrumbs = [
  { label: 'Home', href: '/en/' },
  { label: 'Related Sites', href: '/en/related' },
  { label: 'Queen\'s Butler' },
];

const BTN08_ON_NAVY = "relative inline-flex items-center justify-center bg-[#a38e65] text-white font-semibold border border-[#1a2942] px-[42px] py-[16px] text-sm tracking-[0.2em] font-['Noto_Serif_JP',serif] transition-colors duration-300 hover:bg-[#1a2942] hover:text-[#f8f6f0] hover:border-[#a38e65] cursor-pointer whitespace-nowrap before:content-[''] before:absolute before:inset-1 before:border before:border-[#1a2942]/40 before:pointer-events-none before:transition-colors before:duration-300 hover:before:border-[#a38e65]/50";

function NavyBand({ no, ja, en }: { no: string; ja: string; en: string }) {
  return (
    <div className="bg-[#1a2942] border-y border-[#a38e65]/25">
      <div className="max-w-[1680px] mx-auto px-4 sm:px-6 lg:px-10 py-5 sm:py-[26px] flex items-center gap-4 sm:gap-6">
        <img src="/images/brand/jba-logo.png" alt="" aria-hidden="true" className="h-8 w-8 sm:h-9 sm:w-9 object-contain shrink-0 opacity-90" />
        <span className="font-['Playfair_Display',serif] text-[#d7b779] text-xl sm:text-[26px] tracking-[0.1em] shrink-0 leading-none">{no}</span>
        <h2 className="jba-display font-medium text-[#f8f6f0] text-lg sm:text-2xl lg:text-[26px] tracking-[0.06em] leading-tight">{ja}</h2>
        <span className="hidden md:block ml-auto font-['Playfair_Display',serif] italic text-[#a38e65] text-base lg:text-[19px] tracking-[0.12em]">{en}</span>
      </div>
    </div>
  );
}

export default function EnRelatedQueensButlerPage() {
  return (
    <Layout>
      {/* Hero */}
      <section className="relative bg-[#1a2942] overflow-hidden min-h-[460px] lg:min-h-[520px] flex items-center">
        <img src="/images/related/queens-butler/qb-building-night.webp" alt="The Queen's Butler mansion at night" className="absolute inset-0 w-full h-full object-cover object-center" />
        <div className="absolute inset-0 bg-[linear-gradient(90deg,rgba(16,20,26,0.92)_0%,rgba(16,20,26,0.7)_50%,rgba(16,20,26,0.4)_100%)]"></div>
        <div className="relative z-10 w-full max-w-[1680px] mx-auto px-4 sm:px-6 lg:px-10 pt-32 pb-14 lg:pt-36 lg:pb-20">
          <div className="max-w-[700px]">
            <span className="block font-['Playfair_Display',serif] uppercase tracking-[0.32em] text-xs sm:text-[13px] text-[#d7b779] mb-4">Queen's Butler</span>
            <div className="w-12 h-px bg-[#a38e65] mb-6"></div>
            <h1 className="jba-display font-normal text-white text-[clamp(26px,3.2vw,42px)] leading-[1.42] tracking-[0.02em] mb-6">
              A butler salon for women
            </h1>
            <p className="font-['Noto_Serif_JP',serif] text-base sm:text-lg text-white/90 leading-[1.9]">
              A butler salon for women operated by the Japan Butler Association. At the mansion in Aomi, Tokyo, butlers welcome you.
            </p>
          </div>
        </div>
      </section>
      {/* パンくず: ビルボード直後に配置（Yuichi 2026-07-17 指摘②）。共通Breadcrumbのヘッダー逃げpaddingを子セレクタで通常paddingへ上書き */}
      <div className="bg-white [&>div]:!pt-6">
        <Breadcrumb items={breadcrumbs} />
      </div>

      {/* I. About */}
      <NavyBand no="I" ja="What is Queen's Butler?" en="About" />
      <section className="py-12 sm:py-16 bg-white">
        <div className="max-w-[1680px] mx-auto px-4 sm:px-6 lg:px-10">
          <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-center">
            <div className="order-2 lg:order-1 text-left">
              <h3 className="jba-display font-medium text-[#1a2942] text-2xl sm:text-3xl lg:text-[30px] leading-[1.5] tracking-[0.01em] mb-5">
                Time for women, <span className="text-[#a38e65]">in a mansion attended by butlers</span>
              </h3>
              <p className="font-['Noto_Serif_JP',serif] text-base sm:text-lg text-[#333] leading-[1.9] mb-4">
                Queen's Butler is a butler salon for women operated by the Japan Butler Association. At its mansion at 2-7-4 Aomi, Koto-ku, Tokyo, butlers welcome guests.
              </p>
              <p className="font-['Noto_Serif_JP',serif] text-base sm:text-lg text-[#333] leading-[1.9] mb-4">
                In addition to the women-only butler salon, the mansion offers its furnished rooms as a studio and rental space, and a butler apprentice experience for learning butler attire and conduct.
              </p>
              <p className="font-['Noto_Serif_JP',serif] text-base sm:text-lg text-[#333] leading-[1.9]">
                It also runs an online shop offering made-to-order items themed on butler attire.
              </p>
            </div>
            <div className="order-1 lg:order-2">
              <img src="/images/related/queens-butler/qb-door-welcome.webp" alt="A butler welcoming a guest at the door of the mansion" className="w-full h-[300px] sm:h-[400px] md:h-[480px] object-cover border border-[#a38e65]/30" />
            </div>
          </div>
        </div>
      </section>

      {/* II. Highlights */}
      <NavyBand no="II" ja="What Queen's Butler offers" en="Highlights" />
      <section className="py-12 sm:py-16 bg-white">
        <div className="max-w-[1680px] mx-auto px-4 sm:px-6 lg:px-10">
          <div className="grid md:grid-cols-3 gap-8 lg:gap-10">
            {points.map((p) => (
              <article key={p.title} className="flex flex-col bg-white border border-[#e2ddd2] group hover:border-[#a38e65]/70 transition-colors duration-300">
                <div className="relative h-52 overflow-hidden">
                  <img src={p.img} alt={p.alt} className="absolute inset-0 w-full h-full object-cover object-top" />
                </div>
                <div className="p-7 flex flex-col flex-1 text-left">
                  <span className="block font-['Playfair_Display',serif] italic text-[#8f7a56] text-[13px] tracking-[0.06em] mb-1.5">{p.en}</span>
                  <h4 className="jba-display font-medium text-[#1a2942] text-xl mb-3 leading-[1.4]">{p.title}</h4>
                  <p className="font-['Noto_Serif_JP',serif] text-sm text-[#4a4638] leading-[1.9]">{p.desc}</p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* III. Relationship */}
      <NavyBand no="III" ja="Connection with the Association" en="Relationship" />
      <section className="py-12 sm:py-16 bg-white">
        <div className="max-w-[1680px] mx-auto px-4 sm:px-6 lg:px-10">
          <div className="grid lg:grid-cols-2 items-stretch border border-[#e2ddd2] overflow-hidden">
            <div className="relative min-h-[300px] lg:min-h-[400px] bg-black order-1">
              <img src="/images/related/queens-butler/qb-drive-door-open.webp" alt="A butler opening a car door to welcome a guest" className="absolute inset-0 w-full h-full object-cover object-top" />
            </div>
            <div className="order-2 bg-[#1a2942] flex flex-col justify-center px-8 sm:px-12 lg:px-14 py-12 lg:py-16 text-left">
              <span className="block font-['Playfair_Display',serif] italic text-[#a38e65] text-sm tracking-[0.06em] mb-4">Connection with the Association</span>
              <h3 className="jba-display font-medium text-[#f8f6f0] text-2xl sm:text-3xl leading-[1.5] tracking-[0.01em] mb-6">
                Operated by the Association, <span className="text-[#d7b779]">a place to experience butler culture</span>
              </h3>
              <p className="font-['Noto_Serif_JP',serif] text-base text-[#e7e2d8] leading-[1.9] mb-4">
                Queen's Butler is a butler salon operated by the Japan Butler Association. Butlers trained by the Association welcome guests at the mansion, making it one of the places where butler culture is delivered as an experience.
              </p>
              <p className="font-['Noto_Serif_JP',serif] text-base text-[#e7e2d8] leading-[1.9]">
                For those who wish to study systematically after encountering butler attire and conduct through the apprentice experience, Japan Butler Academy, the Association's training institution, provides that pathway.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* IV. Official Site */}
      <NavyBand no="IV" ja="Official site" en="Official Site" />
      <section className="py-12 sm:py-16 bg-white">
        <div className="max-w-[1680px] mx-auto px-4 sm:px-6 lg:px-10">
          <div className="bg-[#f8f6f0] border border-[#a38e65]/30 p-8 sm:p-10 md:p-14 text-center max-w-4xl mx-auto">
            <h3 className="jba-display font-medium text-[#1a2942] text-2xl sm:text-3xl leading-[1.5] mb-4">Queen's Butler official site</h3>
            <p className="font-['Noto_Serif_JP',serif] text-base sm:text-lg text-[#4a4638] leading-[1.9] max-w-2xl mx-auto mb-8">
              For salon reservations, the studio and rental space, the apprentice experience, and the online shop, please visit the official site.
            </p>
            <a href="https://queensbutler.jp/" target="_blank" rel="noopener noreferrer" className="relative inline-flex items-center justify-center gap-2 bg-[#1a2942] text-[#f8f6f0] border border-[#a38e65] px-[46px] py-[18px] text-sm tracking-[0.2em] font-['Noto_Serif_JP',serif] transition-colors duration-300 hover:bg-[#a38e65] hover:text-[#1a2942] hover:border-[#1a2942] cursor-pointer whitespace-nowrap">
              Visit the Queen's Butler official site <i className="ri-external-link-line"></i>
            </a>
          </div>
        </div>
      </section>

      {/* V. FAQ */}
      <NavyBand no="V" ja="Frequently asked questions" en="FAQ" />
      <section className="py-12 sm:py-16 bg-white">
        <div className="max-w-[1680px] mx-auto px-4 sm:px-6 lg:px-10">
          <div className="max-w-4xl mx-auto border-t border-[#e2ddd2]">
            {faqs.map((f) => (
              <div key={f.q} className="border-b border-[#e2ddd2] py-6">
                <h3 className="jba-display font-medium text-[#1a2942] text-lg sm:text-xl leading-[1.5] mb-3 flex items-start gap-3">
                  <span className="font-['Playfair_Display',serif] text-[#a38e65] text-xl leading-none pt-0.5">Q.</span><span>{f.q}</span>
                </h3>
                <div className="space-y-4">{f.a.split(/\n{2,}/).map((s, i) => (
                  <p key={i} className="font-['Noto_Serif_JP',serif] text-sm sm:text-base text-[#4a4638] leading-[1.9] pl-8">{s.trim()}</p>
                ))}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Other related + CTA */}
      <section className="py-12 sm:py-16 bg-[#f8f6f0]">
        <div className="max-w-[1680px] mx-auto px-4 sm:px-6 lg:px-10">
          <h3 className="jba-display font-medium text-[#1a2942] text-xl sm:text-2xl mb-8 text-center">Other related sites</h3>
          <div className="grid md:grid-cols-3 gap-6 lg:gap-8 max-w-5xl mx-auto mb-12">
            {otherRelated.map((it) => (
              <Link key={it.to} to={it.to} className="group flex items-center justify-between bg-white border border-[#e2ddd2] hover:border-[#a38e65]/70 transition-colors duration-300 p-7 text-left">
                <div>
                  <span className="block font-['Noto_Serif_JP',serif] text-xs text-[#8f7a56] tracking-[0.06em] mb-1.5">{it.role}</span>
                  <span className="jba-display font-medium text-[#1a2942] text-lg group-hover:text-[#8f7a56] transition-colors">{it.name}</span>
                </div>
                <span className="text-[#a38e65] text-lg group-hover:translate-x-1 transition-transform">→</span>
              </Link>
            ))}
          </div>
          <div className="bg-[#1a2942] border border-[#a38e65]/45 p-8 sm:p-10 text-center max-w-4xl mx-auto">
            <h3 className="jba-display font-medium text-xl sm:text-2xl text-[#f8f6f0] mb-6">Interested in learning the butler craft?</h3>
            <div className="flex flex-col sm:flex-row gap-4 sm:gap-6 justify-center">
              <Link to="/en/qualifications" className={BTN08_ON_NAVY}>View certifications</Link>
              <Link to="/en/contact" className={BTN08_ON_NAVY}>Contact us</Link>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
}
